/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Self_Organize_Organized_ByInputs */



/**
* | output |
* | --- |
* | "Organized by {name}" |
*
* @param {Self_Organize_Organized_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const self_organize_organized_by = /** @type {((inputs: Self_Organize_Organized_ByInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Self_Organize_Organized_ByInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Organisée par ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Organizada por ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Organizada por ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Gestito da ${i?.name}`)
	return /** @type {LocalizedString} */ (`Organized by ${i?.name}`)
});